import styled from "styled-components";
import { getColor, getSize, responsive } from "~/helpers/style";

export const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin: ${getSize(3.0)} 0;
  gap: ${getSize(2.4)};

  background-color: ${getColor("white")};
  border: solid 1px ${getColor("border")};
  border-radius: ${getSize(0.6)};

  padding: ${getSize(2.4)} ${getSize(1.5)};
  overflow: hidden;
`;

export const SkeletonContainer = styled.div`
  border: none;
  margin: ${getSize(3.0)} 0;
`;

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSize(1.6)};
  flex: 1;
  min-width: 0;
`;

export const Title = styled.p`
  font-weight: 700;
  font-size: ${getSize(2.0)};
  line-height: ${getSize(3.0)};
  margin: 0;
  max-width: 28ch;

  ${responsive("tablet")} {
    max-width: none;
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${getSize(1.8)};

  ${responsive("laptop")} {
    flex-direction: row;
    align-items: center;
  }
`;

export const ClaimOfferButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${getSize(0.8)};
  align-self: stretch;
  background-color: ${getColor("orange")};
  color: ${getColor("white")};
  font-weight: 600;
  font-size: ${getSize(1.6)};
  padding: ${getSize(1.0)} ${getSize(3.0)};
  text-decoration: none;
  border: none;
  border-radius: ${getSize(0.6)};
  cursor: pointer;
  box-sizing: border-box;

  ${responsive("laptop")} {
    align-self: auto;
  }

  &:hover {
    filter: brightness(0.95);
    color: ${getColor("white")};
  }
`;

export const CollageContainer = styled.div`
  display: none;
  flex-shrink: 0;
  width: min(280px, 32%);
  max-height: 140px;
  overflow: hidden;
  border-radius: ${getSize(0.8)};

  ${responsive("laptop")} {
    display: block;
  }
`;

export const CollageImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
`;
